<template>
  <v-container class="bills-widget">
    <v-row class="bills-widget-row">
      <v-col cols="12" class="bills-widget-col list">
        <v-subheader>{{ lang.financial.bills.widget.periodicals }}</v-subheader>
        <v-list dense>
          <v-list-item
            v-for="(item, i) in list"
            :key="i"
            @click.stop="select_(item)"
            :class="{ 'selected': selected.findIndex(el => el[0] === item.id) >= 0 }"
          >
            <v-list-item-icon>
              <v-icon
                v-if="item.due.days >= 3"
                :color="item.due.color"
              >
                mdi-file-check
              </v-icon>
              <v-icon
                v-else
                :color="`${item.due.color} accent-4`"
              >
                mdi-file-alert
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"/>
              <v-list-item-subtitle>Venc. {{ item.due.text }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-text="formatCurrency(item.value)"/>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-row class="bills-widget-row">
      <v-col cols="12" class="bills-widget-col selected">
        <v-subheader>{{ lang.financial.bills.widget.selected }}</v-subheader>
        <v-list dense>
          <v-list-item
            v-for="(item, i) in selected"
            :key="i"
            class="selected-list"
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-row>
                  <v-col cols="4" class="pa-0 pr-1">
                    <v-text-field
                      v-model="item[1]"
                      :label="lang.financial.bills.widget.form.title"
                      :rules="lang.financial.bills.widget.form.rules.title"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading || item[0] > 0"
                      autocomplete="new-password"
                      filled
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="pa-0 pr-1">
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="190px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-on="on"
                          v-bind="attrs"
                          :value="formatDate(item[2], false)"
                          :label="lang.financial.bills.widget.form.reference"
                          filled
                          readonly
                          hide-details
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item[2]"
                        locale="pt-br"
                        no-title
                        @input="menu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="4" class="pa-0">
                    <v-currency-field
                      v-model="item[3]"
                      :label="lang.financial.bills.widget.form.value"
                      :rules="lang.financial.bills.widget.form.rules.value"
                      :loading="get_interface.loading"
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon 
                @click.stop="deselect_(item)"
              >
                mdi-close-thick
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              @click.prevent="new_()"
              color="primary"
              x-small
              fab
              app
              bottom
              right
            >
              <v-icon small dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ lang.financial.bills.widget.add }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import periodicals from '@/components/financial/periodicals/mixins/index'

export default {
  mixins: [ appdata, utils, periodicals ],
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selected: [ ...this.value ],
      menu: false
    }
  },
  computed: {
    list () {
      let data = (this.get_data || {}).financial || {},
          periodicals = (data.periodicals || []).filter(per => per.type === 2)
      return periodicals.map(per => {
        return {
          ...per,
          due: this.getDue(per)
        }
      })
    }
  },
  watch: {
    selected: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.value) !== JSON.stringify(newVal)) {
          this.$emit('input', [ ...newVal ])
        }
      }
    },
    value: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.selected) !== JSON.stringify(newVal)) {
          this.selected = [ ...newVal ]
        }
      }
    }
  },
  methods: {
    new_ () {
      let selected = this.selected || []
      selected.push([ 0, '', '', 0 ])
    },
    select_ (val) {
      let selected = this.selected || [],
          index = selected.findIndex(el => el[0] === val.id)
      if (index >= 0) {
        selected.splice(index, 1)
      } else {
        selected.push([ val.id, val.title, val.due.date, val.value ])
      }
    },
    deselect_ (val) {
      let selected = this.selected || [],
          index = selected.indexOf(val)
      selected.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" src="./styles/index.scss" />